<template>
  <div class="withdraw_wrap cash-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('cash.withdraw') }}
      </div>
      <button
        type="button"
        class="top_right"
        @click="$router.push('/cashlist')"
      >
        <van-icon
          name="bars"
          size="22"
        />
      </button>
    </div>

    <section class="balance-card">
      <p>{{ $t('sky.jifen') }}</p>
      <strong>{{ data.money }}</strong>
      <span>{{ $t('invest.availableBalance') }}</span>
    </section>

    <div class="wrap_box wrap1">
      <section
        class="choose_bank"
        @click="show = true"
      >
        <div class="choose-label">
          <span>{{ $t('cash.wallet') }}</span>
        </div>
        <div class="choose-value">
          <span>{{ bank_name }}</span>
          <van-icon name="arrow" />
        </div>
      </section>
      <van-action-sheet
        v-model="show"
        :actions="actions"
        cancel-text=""
        :description="this.$t('cash.chooseWallet')"
        close-on-click-action
        @select="onSelect"
      />

      <section class="amount-card">
        <p class="card-title">
          {{ $t('cash.amount') }}
        </p>
        <div class="amount-row">
          <span class="money-mark">{{ utils_moneyMark() }}</span>
          <input
            v-model="form.money"
            type="number"
            step="1"
            class="inp"
            :placeholder="$t('pro2.enteramount')"
            @input="changeAmount"
          >
          <button
            class="allbtn"
            type="button"
            @click="cashall()"
          >
            {{ $t('item.all') }}
          </button>
        </div>
        <p
          v-if="actualAmount"
          class="amount-preview"
        >
          {{ actualAmount }}
        </p>
        <p
          v-if="chargeTip"
          class="charge-tip"
        >
          {{ chargeTip }}
        </p>
      </section>

      <button
        type="button"
        class="basic_btn submit-btn"
        @click="write_psd = true; submitType = 1;"
      >
        {{ $t('utils.submit') }}
      </button>
      <p class="canal_tips">
        {{ $t('cash.arrivalTime') }}
      </p>
    </div>

    <van-popup
      v-model="write_psd"
      closeable
      close-icon="close"
      round
      position="bottom"
      class="password-popup"
    >
      <div class="psw_box">
        <van-password-input
          :value="psd_val"
          :mask="true"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <div class="keybord_box">
          <div class="keybord">
            <button
              v-for="i in 9"
              :key="'num-' + i"
              type="button"
              class="key_item"
              @click="onInput(i)"
            >
              <span class="key_inner">
                {{ i }}
              </span>
            </button>
            <div class="key_item no_bg">
              <div class="key_inner" />
            </div>
            <button
              type="button"
              class="key_item"
              @click="onInput(0)"
            >
              <span class="key_inner">
                0
              </span>
            </button>
            <button
              type="button"
              class="key_item no_bg x"
              @click="onDelete"
            >
              <span class="key_inner">
                x
              </span>
            </button>
          </div>
        </div>
      </div>
    </van-popup>

    <div
      v-show="setPwd"
      class="real_name_mask"
    >
      <div class="real_box">
        <div class="tit" />
        <p class="tips">
          {{ $t('cash.setPwdFirst') }}
        </p>
        <button
          type="button"
          class="basic_btn"
          @click="setIniPwd"
        >
          {{ $t('cash.setNow') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import {
  DropdownMenu,
  DropdownItem,
  Popup,
  PasswordInput,
  NumberKeyboard,
  Icon,
  ActionSheet
} from 'vant';

Vue.use(PasswordInput).use(NumberKeyboard).use(Popup).use(DropdownMenu).use(DropdownItem).use(Icon).use(ActionSheet);

export default {
  name: "Cost",
  data() {
    return {
      data: {},
      showKeyboard: true,
      write_psd: false,
      psd_val: '',
      chargeTip: '',
      charge: 0,
      form: {
        money: '',
        password: '',
        bank_id: 0,
      },
      eye: 1,
      show: false,
      bank_name: this.$t('cash.chooseWallet'),
      actions: [],
      setPwd: false,
      submitType: 1,
      type: 1,
      rate: 1,
      mark: "$",
      actualAmount: ''
    };
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    cashall() {
      this.form.money = this.data.money;
      this.changeAmount();
    },
    onSelect(item) {
      this.chargeTip = "";
      this.actualAmount = "";
      this.form.money = "";
      this.show = false;
      this.bank_name = item.name;
      this.form.bank_id = item.value;
      this.charge = item.charge;
      this.type = item.type;
      this.rate = item.rate;
      this.mark = item.mark;
      if (item.charge > 0) {
        this.chargeTip = this.$t('cash.charge') + item.charge + "%";
      } else {
        this.chargeTip = "";
      }
      if (item.value == 0) {
        this.$router.push('/addcountUsdt');
      }
    },
    changeAmount() {
      this.chargeTip = "";
      var rateTip = "";
      var num = 2;
      if (!this.form.money) {
        this.actualAmount = "";
        return;
      }
      this.actualAmount = this.mark + " " + (this.form.money / this.rate).toFixed(num);
      rateTip = this.mark + " " + (this.form.money * this.charge / 100).toFixed(num);
      if (this.charge > 0) {
        this.chargeTip = this.$t('cash.charge') + rateTip;
      }
    },
    onInput(key) {
      this.psd_val = (this.psd_val + key).slice(0, 6);
      if (this.psd_val.length == 6) {
        this.write_psd = false;
        this.form.password = this.psd_val;
        if (this.submitType == 1) {
          this.submit();
        } else {
          this.setIniPwdSubmit();
        }
      }
    },
    onDelete() {
      this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
    },
    subAll() {
      this.form.money = this.data.money;
    },
    start() {
      Fetch('/user/my_bank').then((r) => {
        this.data = r.data;
        this.data.money = this.data.money.toFixed(2);
        this.setPwd = r.data.intPwd;
        var bankvalue = [];
        r.data.bank.forEach(item => {
          var length = item.account.length;
          var account = item.account + "";
          var itemAccount = account.substr(length - 10, length);
          bankvalue.push({
            name: item.bank + "(****" + itemAccount + ")",
            value: item.id,
            charge: item.charge,
            rate: item.rate,
            type: item.type,
            mark: item.mark
          });
        });
        bankvalue.push({
          name: this.$t('cash.addWallet'),
          value: 0,
          color: "#FF0000",
        });
        this.actions = bankvalue;
        if (bankvalue.length > 1) {
          this.onSelect(bankvalue[0]);
        }
      });
    },
    submit() {
      this.psd_val = "";
      if (!this.form.money) {
        this.$toast(this.$t('cash.withdrawalAmountEmpty'));
        return false;
      }
      if (this.form.money < 0) {
        this.$toast(this.$t('cash.withdrawalAmountNotAllow'));
        return false;
      }
      if (parseInt(this.form.money) > parseInt(this.data.money)) {
        this.$toast(this.$t('cash.withdrawalAmountHigh'));
        return false;
      }
      if (this.form.bank_id == 0 || this.form.bank_id == -1) {
        this.$toast(this.$t('cash.withdrawalAccountEmpty'));
        return false;
      }
      if (!this.form.password || this.form.password.length != 6) {
        this.$toast(this.$t('cash.withdrawalPasswordEmpty'));
        return false;
      }
      Fetch('/user/cost_apply', {
        money: this.form.money,
        bank_id: this.form.bank_id,
        passwd: this.form.password
      }).then(() => {
        this.$toast({
          background: '#07c160',
          message: this.$t('cash.success')
        });
        this.$router.replace('/user');
      });
    },
    setIniPwdSubmit() {
      this.psd_val = "";
      Fetch('/user/setIniPwd', {
        password: this.form.password
      }).then(() => {
        this.setPwd = false;
      });
    },
    setIniPwd() {
      this.submitType = 2;
      this.write_psd = true;
    }
  }
};
</script>

<style lang="less" scoped>
.cash-page {
  min-height: 100vh;
  padding-bottom: 96px;
  background: #111;
  color: #f6f6f6;
  box-sizing: border-box;
}

button {
  border: 0;
  font: inherit;
  cursor: pointer;
}

.page-top {
  background: #111;
  color: #f6f6f6;
  border-bottom: 1px solid #242424;
  box-sizing: border-box;

  .back_left {
    filter: invert(1);
    opacity: 0.88;
  }

  .big_tit {
    max-width: 72%;
    color: #f6f6f6;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: normal;
  }
}

.top_right {
  top: 9px;
  right: 15px;
  width: 32px;
  height: 32px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #8ea0ff;
  background: rgba(101, 123, 233, 0.18);
}

.balance-card,
.choose_bank,
.amount-card,
.canal_tips {
  margin: 14px 16px 0;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid #303030;
  background: #222;
  box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
  box-sizing: border-box;
}

.balance-card {
  padding: 20px 18px;
  text-align: center;
  background: #1f1f1f;
}

.balance-card p,
.balance-card span {
  margin: 0;
  color: #c6cad2;
  font-size: 14px;
  line-height: 20px;
}

.balance-card strong {
  display: block;
  margin: 10px 0 8px;
  overflow: hidden;
  color: #8ea0ff;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.wrap1 {
  margin: 0;
  box-shadow: none;
  background: none;
}

.choose_bank {
  min-height: 56px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.choose-label {
  flex: 0 0 auto;
  margin-right: 12px;
  color: #f6f6f6;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

.choose-value {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #c6cad2;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
}

.choose-value span {
  min-width: 0;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.choose-value .van-icon {
  flex: 0 0 auto;
  margin-left: 6px;
  color: #9aa1aa;
}

.amount-card {
  padding: 16px;
}

.card-title {
  margin: 0;
  color: #f6f6f6;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}

.amount-row {
  min-height: 48px;
  margin-top: 14px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background: #1f1f1f;
  box-sizing: border-box;
}

.money-mark {
  flex: 0 0 auto;
  margin-right: 8px;
  color: #8ea0ff;
  font-size: 16px;
  font-weight: 700;
}

.amount-row input {
  min-width: 0;
  height: 48px;
  flex: 1;
  border: 0;
  outline: none;
  background: transparent;
  color: #f6f6f6;
  font-size: 16px;
  line-height: 48px;
}

.amount-row input::placeholder {
  color: #9aa1aa;
}

.allbtn {
  width: 72px;
  height: 30px;
  flex: 0 0 72px;
  margin-left: 8px;
  border-radius: 8px;
  border: 1px solid #343434;
  background: linear-gradient(100deg, #657be9 0%, #8c52bd 100%) !important;
  color: #8ea0ff;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
}

.amount-preview,
.charge-tip {
  margin: 12px 0 0;
  overflow: hidden;
  color: #9aa1aa;
  font-size: 12px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.basic_btn {
  width: calc(100% - 32px);
  height: 44px;
  margin: 24px 16px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid #343434;
  background: linear-gradient(100deg, #657be9 0%, #8c52bd 100%) !important;
  color: #8ea0ff;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  box-sizing: border-box;
}

.canal_tips {
  padding: 14px 16px;
  color: #9aa1aa;
  font-size: 12px;
  line-height: 20px;
}

/deep/ .van-action-sheet {
  background: #222;
  color: #f6f6f6;
}

/deep/ .van-action-sheet__description {
  color: #c6cad2;
}

/deep/ .van-action-sheet__item {
  background: #222;
  color: #f6f6f6;
  text-align: left;
}

/deep/ .van-popup--bottom {
  border-radius: 12px 12px 0 0;
}

/deep/ .password-popup {
  background: #222;
  color: #f6f6f6;
}

/deep/ .van-password-input {
  margin: 34px 28px 0;
}

/deep/ .van-password-input__security li {
  background: #1f1f1f;
  border-color: #303030;
}

/deep/ .van-password-input__security i {
  background: #fff;
  opacity: 1;
}

/deep/ .van-hairline--left::after {
  border-color: #303030;
}

.keybord_box {
  margin-top: 28px;
  padding: 22px 12px 18px;
  background: #111;
}

.keybord {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  text-align: center;
}

.key_item {
  min-width: 0;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #1f1f1f;
  color: #f6f6f6;
  font-size: 18px;
  font-weight: 700;
  line-height: 44px;
}

.key_item.no_bg {
  background: transparent;
}

.key_item.x {
  color: #c6cad2;
}

.real_name_mask {
  position: fixed;
  z-index: 99;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.58);
}

.real_box {
  width: calc(100% - 48px);
  padding: 24px 16px;
  border-radius: 12px;
  border: 1px solid #303030;
  background: #222;
  box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
  box-sizing: border-box;
}

.tips {
  margin: 0;
  color: #f6f6f6;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
}


.basic_btn,
.history_coupon,
.wallet-btn.is-primary,
.allbtn {
  border: 0;
  background: linear-gradient(100deg, #657be9 0%, #8c52bd 100%) !important;
  color: #fff;
}


.page-top {
  background: #101010;
}

@media screen and (max-width: 374px) {
  .balance-card,
  .choose_bank,
  .amount-card,
  .canal_tips {
    margin-right: 12px;
    margin-left: 12px;
  }

  .basic_btn {
    width: calc(100% - 24px);
    margin-right: 12px;
    margin-left: 12px;
  }

  .allbtn {
    width: 62px;
    flex-basis: 62px;
  }
}
</style>
